import {Pipe, PipeTransform} from "@angular/core";
import {Node}                from "../../_model";


@Pipe({
	name: "noFiles",
	standalone: true
})
export class NoFilesPipe implements PipeTransform {

	constructor() {

	}

	transform(nodes: Node[]): Node[] {
		return nodes.filter(it => it.nodeType === "Directory");

	}

}
